import PropTypes from 'prop-types'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'

import SingleValue from './SingleValue'
import CustomOption from './CustomOption'
import { daysShort } from './helper'

const prepareCell = ({ options, values, setFieldValue, name }) => {
  function CellComponent({ row, cell }) {
    const { t } = useTranslation(['on-call-schedule'])
    const preparedName = row && cell ? `${daysShort[row.id]}${cell.column.id}` : name
    return (
      <Select
        className="select-container"
        classNamePrefix="select-primary"
        options={options}
        name={preparedName}
        value={values[preparedName].value ? values[preparedName] : null}
        components={{ Option: CustomOption, SingleValue }}
        placeholder={t('on-call-schedule:select.selectUser')}
        onChange={(option) => setFieldValue(preparedName, option)}
      />
    )
  }

  CellComponent.propTypes = {
    row: PropTypes.object,
    cell: PropTypes.object,
  }

  return CellComponent
}

export default prepareCell
